var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.$t("label_essweb_customForm_form_previewTitle"),
      pad: "0",
      delBtn: "",
      widthClass: "max-1000",
    },
    scopedSlots: _vm._u([
      {
        key: "page-main",
        fn: function () {
          return [
            _c("Stepper", {
              attrs: { curStep: _vm.curStep, items: _vm.stepper },
              on: {
                step: function (step) {
                  return (_vm.curStep = step)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "content-1",
                  fn: function () {
                    return [
                      _c(
                        "v-container",
                        { staticClass: "pa-0 ma-0", attrs: { fluid: "" } },
                        [
                          _c(
                            "v-sheet",
                            { staticClass: "text-h4 text--primary my-2" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$getCommonLangValue(
                                    _vm.customFormData.application_type_name
                                  )
                                )
                              ),
                            ]
                          ),
                          _c(
                            "v-sheet",
                            { staticClass: "text-body-2 text--secondary my-2" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$getCommonLangValue(
                                    _vm.customFormData.application_type_desc
                                  )
                                )
                              ),
                            ]
                          ),
                          _c(
                            "v-sheet",
                            { staticClass: "text-body-2 text--primary my-2" },
                            [_vm._v("*" + _vm._s(_vm.customFormData.remarks))]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-container",
                        { attrs: { fluid: "" } },
                        [
                          _c(
                            "v-sheet",
                            { staticClass: "text-h4 text--primary my-2" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "label_essweb_customForm_form_termsTitleLabel"
                                  )
                                )
                              ),
                            ]
                          ),
                          _c(
                            "v-container",
                            { staticClass: "pa-0 ma-0", attrs: { fluid: "" } },
                            _vm._l(_vm.NoticeList, function (item, index) {
                              return _vm.$getCommonLangValue(
                                item[
                                  "application_type_notice_point_" + item.number
                                ]
                              ) !== ""
                                ? _c(
                                    "v-sheet",
                                    {
                                      key: "notice--" + index,
                                      staticClass: "d-flex justify-start py-3",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "flex-shrink-1",
                                          staticStyle: { width: "20px" },
                                        },
                                        [
                                          _c("svg-icon", {
                                            attrs: {
                                              size: "12",
                                              fill: item.color_code,
                                              iconClass: "LabeledColour",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c("div", { staticClass: "ml-2" }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$getCommonLangValue(
                                                item[
                                                  "application_type_notice_point_" +
                                                    item.number
                                                ]
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]),
                                    ]
                                  )
                                : _vm._e()
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content-2",
                  fn: function () {
                    return [
                      _c(
                        "v-form",
                        { ref: "form", attrs: { "lazy-validation": "" } },
                        [
                          _c(
                            "v-row",
                            _vm._l(_vm.desserts, function (item, index) {
                              return _c("DynamicForm", {
                                key: "formitem--" + index,
                                attrs: { data: item },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "page-actions",
        fn: function () {
          return undefined
        },
        proxy: true,
      },
      {
        key: "tools-main",
        fn: function () {
          return undefined
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }